import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {map, take} from 'rxjs/operators';
import {AuthenticationService} from '../_services/authentication.service';

export const signOutGuard: CanActivateFn = () => {
  const authenticationService = inject(AuthenticationService);

  return authenticationService.clearData()
    .pipe(
      take(1),
      map(() => true)
    );
};
